/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import matchAll from 'string.prototype.matchall';
// @ts-expect-error no typed file
import replaceAll from 'string.prototype.replaceall';

// polyfill for older browser
// https://app.bugsnag.com/mego-international-promotion-co-dot-ltd/store-frontend/errors/67d93daf4a63f0076609b60f
// https://app.bugsnag.com/mego-international-promotion-co-dot-ltd/store-frontend/errors/67d9830756e2cb408ae9a50a
// https://app.bugsnag.com/mego-international-promotion-co-dot-ltd/store-frontend/errors/67f4e5e83d84835666ae08e5
matchAll.shim();
replaceAll.shim();
if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'undefined') {
  import('resize-observer-polyfill').then(module => {
    window.ResizeObserver = module.default;
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
